import { SlotDaysResponse } from 'api/definitions/slotdays/types';
import { Slot } from 'redux/modules/slots/state/initial-state';

export const flattenSlots = ({ content }: SlotDaysResponse, branchId: string) =>
  content.reduce<Slot[]>((transformedSlots, { slots, date }) => {
    slots.forEach(slot => {
      transformedSlots.push({
        ...slot,
        date,
        branchId,
        slotRangeCopy: '',
        slotId: slot.id,
        slotStatus: slot.status,
      });
    });
    return transformedSlots;
  }, []);
